import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Box, Container, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { userApi } from "api/user/user";
import Loading from "components/lodingState/loading";
import UserInfo from "components/profile/userInfos";
import { useUserContext } from "context/userContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const roleMapping = {
  1: "Administrator",
  2: "User",
  3: "Fitter",
  3: "Sales",
};

const UserProfile = () => {
  const { isAuth } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuth) {
      navigate("/");
    }
  });

  const {
    data: user,
    isLoading,
    error,
    isError,
  } = useQuery({
    queryKey: ["user"],
    queryFn: userApi.get,
  });

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <h1>ERROR</h1>;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 1 }}>
      {user?.data?.data && (
        <>
          <Box
            sx={{
              bgcolor: "gray",
              p: "20px",
              height: { xs: "auto", md: "70px" },
              color: "white",
              display: "flex",
              alignItems: "center",
              gap: { xs: "2px", sm: "10px" },
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <AccountCircleIcon
              sx={{ fontSize: { xs: "60px", sm: "50px" }, mb: { xs: "7px" } }}
            />
            <Typography
              component="p"
              fontSize={{ xs: 17, sm: 22 }}
              sx={{
                fontWeight: "100",
                ml: { xs: "0", sm: "5px" },
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              Brugerinformation :
            </Typography>
            <Typography
              component="p"
              fontSize={{ xs: 23, sm: 22 }}
              sx={{ textAlign: { xs: "center", sm: "left" } }}
            >
              {user.data.data.full_name}
            </Typography>
          </Box>

          <Box
            sx={{
              bgcolor: "whitesmoke",
              p: { xs: "20px", sm: "30px" },
            }}
          >
            <UserInfo info={user.data.data.full_name} label="Kunde :" />
            <UserInfo info={roleMapping[user.data.data.role]} label="Rolle :" />
            <UserInfo info={user.data.data.phone} label="Telefon :" />
            <UserInfo info={user.data.data.email} label="E-mail :" />
          </Box>
        </>
      )}
    </Container>
  );
};
export default UserProfile;
